// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your translation files
import enTranslations from './locales/en/translation.json';
import itTranslations from './locales/it/translation.json';

// Initialize i18next with languages
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    it: { translation: itTranslations },
  },
  lng: localStorage.getItem("lang")!==undefined?localStorage.getItem("lang"):'it', // Default language
  fallbackLng: 'it', // Fallback language if the translation is not found
  interpolation: { escapeValue: false }, // React already escapes by default
});

export default i18n;
